import { useEffect, useState } from "react";
import { useLanguage } from "../i18n/LanguageContext";

const PLACEHOLDER = "https://placehold.co/260x160/1a1a1a/ff0033?text=Video";

const VideoThumbnail = ({ video }) => {
  const [attempt, setAttempt] = useState(0);
  const [failed, setFailed] = useState(false);
  const processing = video.thumbnail_status === "processing";
  // Large uploads can remain in Bunny's encoder for several minutes.
  const maxAttempts = processing ? 60 : 2;

  useEffect(() => {
    setAttempt(0);
    setFailed(false);
  }, [video.thumbnail, video.thumbnail_status]);

  const retry = () => {
    if (attempt + 1 < maxAttempts) {
      window.setTimeout(() => setAttempt((current) => current + 1), processing ? 10000 : 1500);
      return;
    }
    setFailed(true);
  };

  if (!video.thumbnail || failed) {
    return <img src={PLACEHOLDER} className="card-img-top" alt={video.title} style={{ height: "160px", objectFit: "cover", display: "block", width: "100%" }} />;
  }

  const signed = /[?&]token=/.test(video.thumbnail);
  const separator = video.thumbnail.includes("?") ? "&" : "?";
  const source = signed ? video.thumbnail : `${video.thumbnail}${separator}thumbnail_attempt=${attempt}`;
  return <img key={attempt} src={source}
    className="card-img-top" alt={video.title}
    style={{ height: "160px", objectFit: "cover", display: "block", width: "100%" }}
    onError={retry} />;
};

const VideoRow = ({ title, iconUrl = null, eyebrow = "Subcategory", videos = [], onPlay }) => {
  const { t } = useLanguage();
  return (
    <section className="mb-5 hpa-subcategory-section" aria-label={title}>
      <div className="hpa-subcategory-heading">
        <span className="hpa-subcategory-icon" aria-hidden="true">
          {iconUrl ? (
            <img src={iconUrl} alt="" />
          ) : (
            <i className="fa-solid fa-dumbbell" />
          )}
        </span>
        <div>
          <span className="hpa-subcategory-label">{t(eyebrow)}</span>
          <h3>{title}</h3>
        </div>
      </div>

      {videos.length > 0 ? (
        <div className="d-flex overflow-auto gap-3 pb-2 hpa-video-row">
          {videos.map((video) => (
          <div
            key={video.id}
            style={{ minWidth: "260px", cursor: "pointer", flexShrink: 0 }}
            className="card shadow-sm"
            onClick={() => onPlay(video)}
          >
            <div style={{ position: "relative", background: "#111" }}>
            
              <VideoThumbnail video={video} />
              {/* play icon overlay */}
              <div
                style={{
                  position: "absolute",
                  inset: 0,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  opacity: 0,
                  transition: "opacity 0.2s",
                }}
                className="video-play-overlay"
              >
                <i
                  className="fa fa-play-circle"
                  style={{ fontSize: "48px", color: "#fff", filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.8))" }}
                />
              </div>
            </div>

            <div className="card-body py-2 px-3">
              <h6 className="mb-0" style={{ fontSize: "13px", lineHeight: "1.4" }}>{video.title}</h6>
              {video.duration_seconds > 0 && (
                <small className="text-muted">{formatDuration(video.duration_seconds)}</small>
              )}
            </div>
          </div>
          ))}
        </div>
      ) : (
        <div className="hpa-subcategory-empty">
          <i className="fa-regular fa-circle-play" aria-hidden="true" />
          <span>{t("Videos for this subcategory will be added soon.")}</span>
        </div>
      )}

      <style>{`
        .card:hover .video-play-overlay { opacity: 1 !important; }
        .card:hover { transform: translateY(-2px); transition: transform 0.2s; }
      `}</style>
    </section>
  );
};

const formatDuration = (seconds) => {
  if (!seconds) return "";
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return `${m}:${String(s).padStart(2, "0")}`;
};

export default VideoRow;
